import { authGuard, permissionGuard } from '@abp/ng.core';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'account',
    loadChildren: () =>
      import('@volo/abp.ng.account/public').then(m => m.AccountPublicModule.forLazy()),
  },
  {
    path: 'gdpr',
    loadChildren: () => import('@volo/abp.ng.gdpr').then(m => m.GdprModule.forLazy()),
  },
  {
    path: 'identity',
    loadChildren: () => import('@volo/abp.ng.identity').then(m => m.IdentityModule.forLazy()),
  },
  {
    path: 'language-management',
    loadChildren: () =>
      import('@volo/abp.ng.language-management').then(m => m.LanguageManagementModule.forLazy()),
  },
  {
    path: 'saas',
    loadChildren: () => import('@volo/abp.ng.saas').then(m => m.SaasModule.forLazy()),
  },
  {
    path: 'audit-logs',
    loadChildren: () =>
      import('@volo/abp.ng.audit-logging').then(m => m.AuditLoggingModule.forLazy()),
  },
  {
    path: 'openiddict',
    loadChildren: () =>
      import('@volo/abp.ng.openiddictpro').then(m => m.OpeniddictproModule.forLazy()),
  },
  {
    path: 'text-template-management',
    loadChildren: () =>
      import('@volo/abp.ng.text-template-management').then(m =>
        m.TextTemplateManagementModule.forLazy()
      ),
  },
  {
    path: 'setting-management',
    loadChildren: () =>
      import('@abp/ng.setting-management').then(m => m.SettingManagementModule.forLazy()),
  },
  {
    path: 'gdpr-cookie-consent',
    loadChildren: () =>
      import('./gdpr-cookie-consent/gdpr-cookie-consent.module').then(
        m => m.GdprCookieConsentModule
      ),
  },
  {
    path: 'operator-resource',
    loadChildren: () =>
      import('./operator-resource/operator-resource.module').then(
        m => m.OperatorResourceModule
      )
  },
  { path: 'machine-resource',
    loadChildren: () =>
      import('./machine-resource/machine-resource.module').then(
        m => m.MachineResourceModule
      )
  },
  { path: 'resources',
    loadChildren: () =>
      import('./resource/resource.module').then(
        m => m.ResourceModule
      )
  },
  { path: 'requests',
    loadChildren: () =>
      import('./request/request.module').then(
        m => m.RequestModule
      )
  },
  { path: 'resource-registration-request',
    loadChildren: () =>
      import('./resource-registration-request/resource-registration-request.module').then(
        m => m.ResourceRegistrationRequestModule
      )
  },
  { path: 'capacities',
    loadChildren: () =>
      import('./capacity/capacity.module').then(
        m => m.CapacityModule
      )
  },
  { path: 'programmings',
    loadChildren: () =>
      import('./programming/programming.module').then(
        m => m.ProgrammingModule
      )
  },
  { path: 'Approvals',
    loadChildren: () =>
      import('./approvals/approvals.module').then(
        m => m.ApprovalsModule
      )
  },
  {
    path: 'sync-monitor',
    loadChildren: () =>
      import('./shared/synchronization/sync-monitor/sync-monitor.module').then(
        (m) => m.SyncMonitorModule
      ),
  },
  {
    path: 'About',
    loadChildren: () =>
      import('./about/about.module').then(
        m => m.AboutModule
      )
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
